// URL kind registry — mirror of src/shared/constants/url-kinds.js for frontend use

export const URL_KINDS = {
  calendar: {
    label: 'Election calendar',
    icon: '📅',
    description: 'Calendar page with election dates and deadlines',
    scrapeable: true,
    singleton: true,
    storage: 'authorityColumn',
  },
  website: {
    label: 'Official website',
    icon: '🌐',
    description: 'Main election authority website',
    scrapeable: false,
    singleton: true,
    storage: 'authorityColumn',
  },
  meetings: {
    label: 'Meeting minutes',
    icon: '🏛️',
    description: 'Council/board meeting minutes and transcripts',
    scrapeable: false,
    singleton: false,
    storage: 'dataSource',
  },
  policies: {
    label: 'Policies & ordinances',
    icon: '📜',
    description: 'Municipal code, ordinances, and policies',
    scrapeable: false,
    singleton: false,
    storage: 'dataSource',
  },
  minutes: {
    label: 'Meeting minutes',
    icon: '📋',
    description: 'Official meeting minutes (distinct from transcripts)',
    scrapeable: false,
    singleton: false,
    storage: 'dataSource',
  },
  code: {
    label: 'Municipal code',
    icon: '⚖️',
    description: 'Codified laws and regulations',
    scrapeable: false,
    singleton: true,
    storage: 'dataSource',
  },
  polling: {
    label: 'Polling locations',
    icon: '🗳️',
    description: 'Polling place finder or location list',
    scrapeable: true,
    singleton: true,
    storage: 'dataSource',
  },
  registration: {
    label: 'Voter registration',
    icon: '📝',
    description: 'Voter registration information and deadlines',
    scrapeable: false,
    singleton: true,
    storage: 'dataSource',
  },
  voter_id: {
    label: 'Voter ID / identification requirements',
    icon: '🆔',
    description: 'Identification requirements for voting',
    scrapeable: false,
    singleton: true,
    storage: 'dataSource',
  },
  absentee: {
    label: 'Absentee / mail voting',
    icon: '📬',
    description: 'Mail-in ballot and absentee voting information',
    scrapeable: false,
    singleton: true,
    storage: 'dataSource',
  },
  scraper: {
    label: 'Scraper source',
    icon: '🤖',
    description: 'Primary URL for automated scraping',
    scrapeable: true,
    singleton: true,
    storage: 'dataSource',
  },
  other: {
    label: 'Other',
    icon: '📎',
    description: 'Other relevant URL',
    scrapeable: false,
    singleton: false,
    storage: 'dataSource',
  },
};
